var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "com-button-icon",
      class: { "com-button-icon--active": _vm.active }
    },
    [_c("font-awesome-icon", { attrs: { icon: _vm.icon } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }